import React, { useState } from 'react';
import { styled, alpha } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import logoMinistere from "../../assets/logoMinistere.jpg"
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Avatar } from '@mui/material';
import AccountCircle from '@mui/icons-material/AccountCircle';
import logoMadagascar from '../../assets/logo_mada.png'
import ChartMsanp from './ChartMsanp';
import logoMsamp from "../../assets/logo_officiel.png"
import presidence from "../../assets/presidence1.png"
import { grey } from '@mui/material/colors';



const Search = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
        backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing(3),
        width: 'auto',
    },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: 'inherit',
    '& .MuiInputBase-input': {
        padding: theme.spacing(1, 1, 1, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)})`,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('md')]: {
            width: '20ch',
        },
    },
}));


function Navbar({ onChangeSearchValue, searchValue }) {
    const navigate = useNavigate()
    const location = useLocation()
    const [anchorElNav, setAnchorElNav] = useState(null);
    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };
    const changeSearchValue = (e) => {
        const valeur = e.target.value
        onChangeSearchValue(valeur)
    }

    return (
        <AppBar position="static" style={{ backgroundColor: grey[400], zIndex: 1000 }}>
            <Container maxWidth="xl" >
                <Toolbar disableGutters>
                    <Box component='img' src={logoMsamp}
                        alt="Logo"
                        sx={{
                            display: { xs: 'none', sm: 'block' },
                            width: 70,
                            height: 70,
                            cursor:'pointer',
                            marginLeft:'60px'
                        }} onClick={()=>{
                            window.location.href="/"
                        }} />
                    {/* <Avatar src={logoMinistere} sx={{ display: { xs: 'none', md: 'flex' }, background: 'white', mr: 1 }} /> */}
                    {/* <AdbIcon sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }} /> */}
                    {/* <Typography
                        variant="h6"
                        noWrap
                        component='a'
                        href="/"
                        sx={{
                            mr: 2,
                            display: { xs: 'none', md: 'flex' },
                            fontFamily: 'monospace',
                            fontWeight: 700,
                            letterSpacing: '.3rem',
                            color: 'inherit',
                            textDecoration: 'none',
                        }}
                    >
                        MSANP
                    </Typography> */}

                    <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                        <IconButton
                            size="large"
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleOpenNavMenu}
                            color="inherit"
                        >
                            <MenuIcon />
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorElNav}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            // open={Boolean(anchorElNav)}
                            // onClose={handleCloseNavMenu}
                            sx={{
                                display: { xs: 'block', md: 'none' },
                            }}
                        >
                            {/* <MenuItem onClick={handleCloseNavMenu} component={Link} to="/doleance">
                                <Typography textAlign="center">Fanamarihana</Typography>
                            </MenuItem> */}
                        </Menu>
                    </Box>
                    {/* <Avatar src={logoMinistere} sx={{ display: { xs: 'flex', md: 'none' }, mr: 1 }} /> */}
                    {/* <AdbIcon sx={{ display: { xs: 'flex', md: 'none' }, mr: 1 }} /> */}
                    {/* <Typography
                        variant="h5"
                        noWrap
                        component="a"
                        href="/"
                        sx={{
                            mr: 2,
                            display: { xs: 'flex', md: 'none' },
                            flexGrow: 1,
                            fontFamily: 'monospace',
                            fontWeight: 700,
                            letterSpacing: '.3rem',
                            color: 'inherit',
                            textDecoration: 'none',
                        }}
                    >
                        MSANP
                    </Typography> */}
                    <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                        {/* <Button
                            onClick={handleCloseNavMenu}
                            sx={{ my: 2, color: 'white', display: 'block' }}
                            component={Link}
                            to="/doleance"
                            variant='text'
                            style={{ textTransform: 'none', backgroundColor: location.pathname == '/doleance' ? 'rgb(245,100,150)' : '' }}
                        >
                            Fitarainana
                        </Button> */}
                    </Box>
                    <Box sx={{ flexGrow: 1 }}>
                        <Box component='img' src={presidence}
                            alt="présidence"
                            sx={{
                                display: { xs: 'none', sm: 'block' },
                                width: 150,
                                height: 70,
                            }} />
                    </Box>
                    <Box sx={{ flexGrow: 0 }}>
                        <Search>
                            <SearchIconWrapper>
                                <SearchIcon />
                            </SearchIconWrapper>
                            <StyledInputBase
                                // placeholder="Recherche…"
                                placeholder="Fikarohana…"
                                // inputProps={{ 'aria-label': 'Recherche' }}
                                inputProps={{ 'aria-label': 'Fikarohana' }}
                                onChange={changeSearchValue}
                                value={searchValue}
                            />
                        </Search>
                    </Box>
                    {/* <Box>
                        <IconButton
                            size="large"
                            edge="end"
                            aria-label="account of current user"
                            // aria-controls={menuId}
                            // aria-haspopup="true"
                            // onClick={handleProfileMenuOpen}
                            color="inherit"
                        >
                            <Avatar src={logoMadagascar} />
                        </IconButton>
                    </Box> */}
                </Toolbar>
            </Container>
        </AppBar>
    );
}
export default Navbar;
